module.exports = __webpack_public_path__ + "media/assets/community/info-logo-105a59f35c6e0f2819bac0e9f679144d2b82d140bc30fa6948399ecc343fcee8.png";